var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[(_vm.dark) ? 'dark' : '', _vm.customClass ? _vm.customClass : ''],attrs:{"id":"app"}},[_c('Nav'),_c('router-view',{key:_vm.reloadView}),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }